var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave10S1440Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      zIndex: 1,
      position: "relative",
      shapeRendering: "auto"
    },
    width: 1440,
    height: 705,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1440 705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,352.5) scale(1,1) translate(-720,-352.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.5142388463408638",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff00ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.5142388463408638)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "0s",
    values: "M0 0L 0 629.9739540338603Q 144 573.1023769627953  288 538.6085065775159T 576 514.4042204332272T 864 424.51316721944073T 1152 318.5383260851739T 1440 369.6952687062721L 1440 0 Z;M0 0L 0 652.8062950752796Q 144 630.9470538151412  288 604.5968716585551T 576 495.01974705601253T 864 382.3879773056727T 1152 444.73776922909724T 1440 355.3892063056555L 1440 0 Z;M0 0L 0 604.5619690404872Q 144 626.3446240002116  288 580.2105976440523T 576 452.54146918139884T 864 453.01991480785716T 1152 324.63897080826393T 1440 348.05674259381317L 1440 0 Z;M0 0L 0 629.9739540338603Q 144 573.1023769627953  288 538.6085065775159T 576 514.4042204332272T 864 424.51316721944073T 1152 318.5383260851739T 1440 369.6952687062721L 1440 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.5142388463408638)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-2s",
    values: "M0 0L 0 624.5999209420265Q 144 582.3074015238146  288 546.4068755529615T 576 530.0419740118828T 864 472.4084608682982T 1152 306.2546601659189T 1440 275.75722752093475L 1440 0 Z;M0 0L 0 641.8803465861888Q 144 578.6910550591584  288 557.1285633172406T 576 518.6756790265598T 864 515.050613387325T 1152 388.86499915480465T 1440 307.9923133725044L 1440 0 Z;M0 0L 0 658.8509954857583Q 144 566.875535518005  288 537.778282631296T 576 539.6733388839971T 864 370.251961665563T 1152 304.9236302575824T 1440 326.6753320876629L 1440 0 Z;M0 0L 0 624.5999209420265Q 144 582.3074015238146  288 546.4068755529615T 576 530.0419740118828T 864 472.4084608682982T 1152 306.2546601659189T 1440 275.75722752093475L 1440 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.5142388463408638)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-4s",
    values: "M0 0L 0 591.7006195590304Q 144 629.5799242933776  288 610.8228784731662T 576 556.3032934743799T 864 451.0609330560804T 1152 402.2457172965279T 1440 337.47602178681893L 1440 0 Z;M0 0L 0 625.5874022852757Q 144 651.0452650794085  288 622.0248585897853T 576 500.7126326008911T 864 457.0440238076643T 1152 422.29538656417776T 1440 344.42299502034075L 1440 0 Z;M0 0L 0 649.146785864125Q 144 639.4145405494924  288 620.6109425426209T 576 557.5906484664922T 864 488.1196818190726T 1152 329.1983964385207T 1440 320.09486459514073L 1440 0 Z;M0 0L 0 591.7006195590304Q 144 629.5799242933776  288 610.8228784731662T 576 556.3032934743799T 864 451.0609330560804T 1152 402.2457172965279T 1440 337.47602178681893L 1440 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.5142388463408638)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-6s",
    values: "M0 0L 0 651.7618499617582Q 144 618.7151587869001  288 590.0957416376539T 576 561.7533367389842T 864 428.43234127463705T 1152 343.69204172703525T 1440 280.20962919369657L 1440 0 Z;M0 0L 0 676.6403985310037Q 144 630.9558250144208  288 584.1030383249323T 576 498.1101243292728T 864 420.3442916054561T 1152 349.8653279234855T 1440 401.1516170525932L 1440 0 Z;M0 0L 0 682.5168164963154Q 144 644.4382233005296  288 592.5572238734572T 576 459.7408611548019T 864 484.7664516085905T 1152 343.66042362416243T 1440 273.31701136379286L 1440 0 Z;M0 0L 0 651.7618499617582Q 144 618.7151587869001  288 590.0957416376539T 576 561.7533367389842T 864 428.43234127463705T 1152 343.69204172703525T 1440 280.20962919369657L 1440 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.5142388463408638)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-8s",
    values: "M0 0L 0 640.8758196280671Q 144 640.9195995823045  288 600.2443420351228T 576 511.64160446090096T 864 466.00864937090535T 1152 416.3566892396865T 1440 319.98139888793474L 1440 0 Z;M0 0L 0 646.1891085591626Q 144 629.8132716100281  288 616.0086317428584T 576 555.8611534568273T 864 474.8969425917777T 1152 344.2074056616551T 1440 341.6835189661003L 1440 0 Z;M0 0L 0 600.2633783069716Q 144 595.2335367585805  288 571.1764569607471T 576 555.4912557631962T 864 419.1504982126637T 1152 368.02774651179317T 1440 285.9349614886189L 1440 0 Z;M0 0L 0 640.8758196280671Q 144 640.9195995823045  288 600.2443420351228T 576 511.64160446090096T 864 466.00864937090535T 1152 416.3566892396865T 1440 319.98139888793474L 1440 0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave10S1440Px);
export default __webpack_public_path__ + "static/media/wave_10s_1440px.442d13c555451eeaac3bc979712fe0db.svg";
export { ForwardRef as ReactComponent };